import angular from "angular";
import { ICartItem } from "../model/domain/ICartItem";

/**
 * @deprecated 
 */
export class CartRestService {

    public static readonly $inject: string[] = ["$rest", "runtimeContext"];

    constructor(private $rest: qpmn.common.rest.IRestService, private runtimeContext: qpmn.main.IRuntimeContext) { }

    /**
     * @description 获取当前token下的购物车数据
     * @returns 
     */
    public getCart(): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.cart.model.domain.ICartData>> {

        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<qpmn.cart.model.domain.ICartData>("userCartRestService", "getCart");
        } else {
            return this.$rest.http<qpmn.cart.model.domain.ICartData>("partnerCartRestService", "getCart");
        }
    }

    /**
     * @description 更新购物车项
     * @param shoppingCartItemId 
     * @param qty 
     * @returns 
     */
    public updateItem(shoppingCartItemId: string, updateParams: qpmn.cart.model.domain.ICartParams): angular.IPromise<qpmn.common.rest.IRestResponse<ICartItem>> {

        let requestParams: qpmn.cart.model.domain.IUpdateCartParams = {
            shoppingCartItemId: shoppingCartItemId
        };

        angular.extend(requestParams, updateParams);

        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<ICartItem>("userCartRestService", "updateItem", requestParams);
        } else {
            return this.$rest.http<ICartItem>("partnerCartRestService", "updateItem", requestParams);
        }

    }

    /**
     * @description 批量删除购物车项
     * @param itemIds id列表
     * @returns 
     */
    public multiDelete(itemIds: string): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        if (this.runtimeContext.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$rest.http<boolean>("userCartRestService", "multiDelete", {
                itemIds: itemIds
            });
        } else {
            // partner购物车
            return this.$rest.http<boolean>("partnerCartRestService", "multiDelete", {
                itemIds: itemIds
            });
        }

    }

    /**
     * @description 删除购物车项
     * @param shoppingCartItemId 
     * @returns 
     */
    public deleteCartItem(shoppingCartItemId: string): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<boolean>("userCartRestService", "deleteCartItem", {
                shoppingCartItemId: shoppingCartItemId
            });
        } else {
            return this.$rest.http<boolean>("partnerCartRestService", "deleteCartItem", {
                shoppingCartItemId: shoppingCartItemId
            });
        }

    }

    /**
     * @description 计算结算总价
     * @param selectedList 
     */
    public totalPrice(selectedList: string): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.cart.model.domain.ITotalPrice>> {
        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<qpmn.cart.model.domain.ITotalPrice>("userCartRestService", "totalPrice", {
                itemIds: selectedList
            });
        } else {
            return this.$rest.http<qpmn.cart.model.domain.ITotalPrice>("partnerCartRestService", "totalPrice", {
                itemIds: selectedList
            });
        }

    }



    /**
     * @description 添加至购物车
     * @param configurableProductId 
     * @returns 
     */
    public addToCart(cartParams: qpmn.cart.model.domain.ICartParams): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {

        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<boolean>("userCartRestService", "addToCart", cartParams);
        } else {
            return this.$rest.http<boolean>("partnerCartRestService", "addToCart", cartParams);
        }


    }

    /**
     * @description 合并购物车
     * @param anonymousUserId 
     */
    public mergeCart(anonymousUserId: number): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("partnerCartRestService", "mergeCart", {
            anonymousUserId: anonymousUserId
        });
    }

    /**
     * @description 获取单个购物车项
     * @param shoppingCartItemId 
     * @returns 
     */
    public getItem(shoppingCartItemId: string): angular.IPromise<qpmn.common.rest.IRestResponse<any>> {
        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<any>("userCartRestService", "getItem", {
                shoppingCartItemId: shoppingCartItemId
            });
        } else {
            return this.$rest.http<any>("partnerCartRestService", "getItem", {
                shoppingCartItemId: shoppingCartItemId
            });
        }

    }

    /**
     * @description 批量获取购物车项
     * @param itemIds 
     * @returns 
     */
    public getMultiItems(itemIds: string): angular.IPromise<qpmn.common.rest.IRestResponse<any>> {
        if (this.runtimeContext.isAnonymous()) {
            return this.$rest.http<any>("userCartRestService", "getMultiItems", {
                itemIds: itemIds
            });
        } else {
            return this.$rest.http<any>("partnerCartRestService", "getMultiItems", {
                itemIds: itemIds
            });
        }
    }


    /**
     * @description: 批量获取特定地区购物车项信息
     * @param {string} itemsIds
     * @param {string} countryCode
     * @return {*}
     */
    public getSpecificMultiItems(itemIds: string, countryCode: string): angular.IPromise<qpmn.common.rest.IRestResponse<Array<ICartItem>>> {
        return this.$rest.http<any>("partnerCartRestService", "getMultiItems", {
            itemIds: itemIds
        }, {
            "saleRegions-country": countryCode
        })
    }

    /**
     * @description: 生成预拼单项
     */
    public cartPreBulkOrder(ids: Array<string>, addressInstance: qpmn.bulkOrder.model.domain.AddressInstance): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("partnerCartRestService", "cartPreBulkOrder", {
            ids: ids,
            addressInstance: addressInstance
        })
    }
}